import { T } from "../lib/theme";

const Spinner = ({ size = 28 }) => (
  <div style={{
    width: size, height: size,
    border: `2px solid ${T.border2}`,
    borderTopColor: T.emerald,
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  }} />
);

export default Spinner;